import {Component, EventEmitter, Input, OnChanges, Output} from '@angular/core';

@Component({
    selector: 'app-verify-new-user',
    templateUrl: './verify-new-user.component.html',
    styleUrls: ['./verify-new-user.component.scss']
})
export class VerifyNewUserComponent implements OnChanges {

    @Input() fullName: any;
    @Input() columns: any;
    @Input() providers: any;
    @Input() licenseKey: any;

    fullNameInvalid = true;
    columnExists = false;
    providerExists = false;

    @Output() isValid = new EventEmitter<any>();

    constructor() {
    }

    ngOnChanges() {
        this.validate();
    }

    validate() {
        console.log('validating...');
        if (!this.fullName || this.fullName.split(' ').length < 2 || (!this.fullName.split(' ')[0].length || !this.fullName.split(' ')[1].length)) {
            this.fullNameInvalid = true;
            this.isValid.emit(false);
        } else {

            this.fullNameInvalid = false;
            this.validateFullName();
        }
    }

    validateFullName() {
        const nameParts = this.fullName.toLowerCase().split(' ');
        const firstName = nameParts[0];
        const lastName = nameParts[1];

        this.columnExists = this.columns.some((column: any) => column.LicenseKey === Number(this.licenseKey) && column.ColumnHeading.toLowerCase().split(',')[0] === this.fullName.toLowerCase());
        this.providerExists = this.providers.some((provider: any) => provider.LicenseKey === Number(this.licenseKey) && provider.FullName.toLowerCase() === lastName + ',' + firstName);

        if (this.columnExists && this.providerExists) {
            this.isValid.emit(true);
        } else {
            this.isValid.emit(false);
        }
    }
}
